registerComponent("sections/pj-credito", function (component) {
/**
 * Crédito — sem comportamento próprio.
 *
 * A entrada escalonada e a pilha `sticky` são do `sections/produtos`.
 */

});
